const regexInput = (value) => {
  // eslint-disable-next-line
  const regex = /[$\{\}<>]/;
  return !regex.test(value);
};

const regexDescription = (value) => {
  // eslint-disable-next-line
  const regex = /[\{\}<>]/;
  return !regex.test(value);
};

const regexEmail = (value) => {
  // This regex allows for common valid email patterns:
  // - Local part: alphanumeric, ., _, %, +, -
  // - Domain part: alphanumeric, ., -
  // - TLD: at least two letters
  const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return regex.test(value);
};

const regexUrl = (value) => {
  const regex = /^[A-Za-z0-9@./]+$/;
  return regex.test(value);
};

const regexPassword = (value) => {
  // eslint-disable-next-line
  const regex = /[$\{\}<>]/;
  return !regex.test(value);
};

export { regexInput, regexDescription, regexEmail, regexUrl, regexPassword };
